<template>
  <div>
    <v-form ref="formDatosPersonales" lazy-validation>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="9" class="pb-0">
              <v-row>
                <v-col cols="12" sm="6" md="4" class="pb-0">
                  <textfieldComp textLabel="Nombres" v-model="persona.nombre_persona" type="text"
                    :rules="validationRules.validateName" :readonly="bloquearInput" @keypress="text" />
                </v-col>

                <v-col cols="12" sm="6" md="4" class="pb-0">
                  <textfieldComp textLabel="Apellido paterno" v-model="persona.ape1_persona" type="text"
                    :rules="validationRules.validateCampo" :readonly="bloquearInput" @keypress="text" />
                </v-col>

                <v-col cols="12" sm="6" md="4" class="pb-0">
                  <textfieldComp textLabel="Apellido materno" v-model="persona.ape2_persona" type="text"
                    :rules="validationRules.validateCampo" :readonly="bloquearInput" @keypress="text" />
                </v-col>

                <v-col cols="12" sm="6" md="4" class="pb-0">
                  <!-- {{ getTipoDocumentos }} -->
                  <AutocompleteComp textLabel="Tipo de documento de identidad" v-model="persona.id_tipo_documento"
                    :items="getTipoDocumentos" item-value="id" item-text="desc_tipo_documento" :readonly="InputUpdate"
                    isDisable />
                </v-col>

                <v-col cols="12" sm="6" md="4" class="pb-0">
                  <textfieldComp textLabel="Número de documento de identidad" v-model="persona.numdoc_persona" type="text"
                    :readonly="InputUpdate" :rules="dinamicValidation" disabled />
                </v-col>

                <v-col cols="12" sm="6" md="4" class="pb-0">
                  <AutocompleteComp textLabel="Sexo" v-model="persona.sexo_persona" :items="sexo" item-text="nombre"
                    item-value="abbr" :rules="validationRules.validateCampo" :readonly="bloquearInput" />
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" sm="12" md="3" class="d-flex justify-center order-md-0 order-first" @click="pickAvatar">
              <v-avatar width="140" height="170" class="avatar_fondo_add_img pa-1">
                <v-icon color="grey lighten-2" class="fondo_add_img" size="60" v-if="!avatar.url && !img">fas
                  fa-user</v-icon>
                <v-img v-if="img" :src="srcImg" aspect-ratio="1" dark contain class="fondo_add_img">
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                <v-img v-if="avatar.url && !img" :src="avatar.url" contain aspect-ratio="1" class="fondo_add_img" />
                <input type="file" style="display: none" ref="imageAvatar" accept=".jpg, .png, .gif"
                  @change="onFileAvatar" />
              </v-avatar>
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted" label="Fecha de nacimiento" v-mask="'##/##/####'"
                    placeholder="dd/mm/yyyy" v-on="on" :rules="validationRules.validateCampo"></v-text-field>
                </template>

                <v-date-picker v-model="persona.fecnac_persona" no-title @input="menu2 = false" :disabled="bloquearInput"
                  :max="fechaMayorEdad">
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <AutocompleteComp textLabel="País de nacimiento" v-model="persona.id_pais_nacimiento" :items="getPaises"
                item-value="id" item-text="nombre_pais" :rules="validationRules.validateCampo" :readonly="bloquearInput"
                @change="select_pais" />
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <AutocompleteComp textLabel="Nacionalidad" v-model="persona.id_nacionalidad" :items="nacionalidades"
                item-value="id" item-text="desc_nacionalidad" :rules="validationRules.validateCampo"
                :readonly="bloquearInput" />
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <AutocompleteComp textLabel="Estado civil" v-model="personal.id_estado_civil" :items="getEstadosCiviles"
                item-value="id" item-text="desc_estado_civil" :rules="validationRules.validateCampo" />
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <AutocompleteComp textLabel="Discapacidad" v-model="personal.id_discapacidad" :items="getDiscapacidades"
                item-value="id" item-text="desc_discapacidad" :rules="validationRules.validateCampo" />
            </v-col>

             <v-col cols="12" sm="6" md="3" class="py-0">
              <AutocompleteComp textLabel="Tipo de personal" v-model="personal.id_tipo_personal" :items="tipo_personal"
                item-value="id" item-text="desc_tipo_personal" :rules="validationRules.validateCampo"
                @change="filterPerfilByTipoPersonal(personal.id_tipo_personal)" :isDisable="perfilEdit" />
            </v-col> 

            <v-col cols="12" sm="6" md="3" class="pa-0">
              <v-container>
                <v-radio-group v-model="personal.estado_personal" mandatory class="py-0 my-0">
                  <label>Estado: </label>
                  <div>
                    <v-radio :label="`Activo`" :value="1" color="teal"></v-radio>
                    <v-radio :label="`Inactivo`" :value="0" color="error"></v-radio>
                  </div>
                </v-radio-group>
              </v-container>
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <v-menu v-model="menu3" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted3" label="Fecha de ingreso" v-mask="'##/##/####'"
                    placeholder="dd/mm/yyyy" v-on="on" :rules="validationRules.validateCampo"></v-text-field>
                </template>
                <v-date-picker v-model="personal.fecha_ingreso" no-title @input="menu3 = false"
                  :max="getEndDate"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="3" v-if="fetchSalida" class="py-0">
              <v-menu v-model="menu4" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted4" label="Fecha de salida" v-mask="'##/##/####'"
                    placeholder="dd/mm/yyyy" readonly v-on="on"></v-text-field>
                </template>

                <v-date-picker v-model="personal.fecha_salida" no-title @input="menu4 = false"
                  :min="personal.fecha_ingreso"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="3" v-if="fetchSalida" class="py-0">
              <AutocompleteComp textLabel="Motivo de salida" v-model="personal.id_motivo_salida" :items="motivo_salida"
                item-value="id" item-text="desc_motivo_salida" />
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <textfieldComp textArea textLabel="Observación" v-model="personal.observacion_personal" />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12" class="pb-0">
              <v-alert dense border="left" class="text-center" color="#0277bd" dark>
                <h3>DATOS DE UBICACIÓN Y CONTACTO</h3>
              </v-alert>
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <AutocompleteComp textLabel="País" v-model="persona.id_pais" :items="getPaises" item-value="id"
                item-text="nombre_pais" :rules="validationRules.validateCampo"
                @change="getAllDepartamentosId(persona.id_pais)" :readonly="bloquearInput" />
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <AutocompleteComp :textLabel="$t('ubicacion.ubicacion1')" v-model="persona.id_ubicacion1"
                :items="getDepartamentos" item-value="id" item-text="nombre_ubicacion1"
                :rules="validationRules.validateCampo" @change="getAllProvinciasId(persona.id_ubicacion1)"
                :readonly="bloquearInput" />
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <AutocompleteComp :textLabel="$t('ubicacion.ubicacion2')" v-model="persona.id_ubicacion2"
                :items="getProvincias" item-value="id" item-text="nombre_ubicacion2"
                :rules="validationRules.validateCampo" @change="getAllDistritosId(persona.id_ubicacion2)"
                :readonly="bloquearInput" />
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <AutocompleteComp :textLabel="$t('ubicacion.ubicacion3')" v-model="persona.id_ubicacion3"
                :items="getDistritos" item-value="id" item-text="nombre_ubicacion3" :rules="validationRules.validateCampo"
                :readonly="bloquearInput" />
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <textfieldComp textLabel="Código postal" v-model="personal.codigo_postal" type="text"
                :rules="validationRules.max50" />
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <textfieldComp textArea textLabel="Dirección" v-model="persona.direc_persona"
                :rules="validationRules.max150" :readonly="bloquearInput" />
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <textfieldComp textLabel="Teléfono fijo" v-model="persona.telf_persona" type="number" min="0"
                @keydown="validarNumeroTelefono" :rules="validationRules.validateMovilphone" :readonly="bloquearInput" />
            </v-col>
            <v-col cols="12" sm="6" md="3" class="py-0">
              <textfieldComp textLabel="Teléfono móvil" v-model="persona.cel_persona" type="number" min="0"
                @keydown="validarNumeroTelefono" :rules="validationRules.validateMovilphone" :readonly="bloquearInput" />
            </v-col>

            <v-col cols="12" sm="6" md="3" class="py-0">
              <textfieldComp textLabel="Correo electrónico" v-model="persona.correo_persona" type="email"
                :rules="validationRules.validateCorreo" />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <!-- CREDENCIALES DE USUARIO -->
        <v-row>
          <v-col cols="12" sm="12" md="12" class="pb-0">
            <v-alert dense border="left" class="text-center" color="#0277bd" dark>
              <h3>CREDENCIALES DE USUARIO</h3>
            </v-alert>
          </v-col>

          <v-col cols="12" sm="6" md="3" class="py-0">
            <v-text-field label="Nombre de usuario" type="text" v-model="persona.usu_usuario" disabled></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="3" class="py-0" v-if="this.parametros.evento == 'agregar'">
            <v-text-field v-model="persona.password_usuario" :append-icon="show ? 'fa-eye' : 'fa-eye-slash'"
              :rules="validationRules.validatePassword" :type="show ? 'text' : 'password'" label="Contraseña"
              @click:append="show = !show">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="py-0" v-if="!habilitarUsMaster">
            <v-autocomplete v-model="persona.id_perfil" :items="Perfil" item-text="descripcion_perfil"
              item-value="id_perfil" @change="cargarLicenciaTipo(persona.id_perfil)"
              :rules="validationRules.validateCampoList" label="Perfil" :disabled="perfilEdit" auto-select-first>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="py-0" v-if="!habilitarUsMaster">
            <v-select label="Tipo de licencia" v-model="persona.id_licencia_tipo" :items="LicenciaTipo" item-value="id"
              item-text="desc_tipo_licencia" :readonly="persona.fecha_fin > new Date().toISOString().substr(0, 10)
                " disabled>
            </v-select>
          </v-col>

          <v-col cols="12" sm="6" md="6" class="py-0" v-if="persona.fecha_fin > new Date().toISOString().substr(0, 10)">
            Licencia
            <p class="black--text">{{ persona.serie_licencia }}</p>
          </v-col>

          <v-col cols="12" sm="6" md="6" class="py-0" v-else>
            <v-autocomplete label="Licencias" v-model="persona.id_licencia" :items="Licencia" item-value="id"
              item-text="serie_licencia" disabled>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" md="6">
            <ButtonComp disabled iconBut="fas fa-tools" @click="configPermisos()" tooltip-text="Configurar permisos"
              class-color="primary" />
          </v-col>

          <ComunDialogComp title="Configurar permisos" v-model="dialogPermisos" maxWidth="600"
            @close-modal="dialogPermisos = false">
            <template v-slot:body>
              <v-row>
                <v-col cols="12" class="d-flex justify-center">
                  <v-chip small label class="mx-2">
                    {{ persona.usu_usuario }}
                  </v-chip>
                  -
                  <v-chip small label class="mx-2">
                    {{ persona.desc_tipo_licencia }}
                  </v-chip>
                </v-col>
                <v-col cols="12">
                  <AutocompleteComp textLabel="Modulo" item-value="id" v-model="configuracion.id_modulo" :items="modulo"
                    item-text="nombre_modulo" @change="cargarSubModulo" :rules="validationRules.validateCampoList" />
                </v-col>
                <v-col cols="12">
                  <v-row>
                    <v-col cols class="py-0">
                      <label class="font-weight-black black--text">
                        <h3>Submódulos</h3>
                      </label>
                    </v-col>

                    <v-col cols="1" class="py-0 btn_ver d-flex justify-center">
                      <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" dark x-small>fa-eye</v-icon>
                        </template>
                        <span>VISUALIZAR</span>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="1" class="py-0 btn_otro d-flex justify-center">
                      <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                          <div class="grid">
                            <v-icon dark x-small v-on="on">fa-plus</v-icon>
                          </div>
                        </template>
                        <span>AGREGAR</span>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="1" class="py-0 btn_editar d-flex justify-center">
                      <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                          <v-icon dark x-small v-on="on">fa-pencil-alt</v-icon>
                        </template>
                        <span>EDITAR</span>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="1" class="py-0 btn_eliminar d-flex justify-center">
                      <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                          <v-icon dark x-small v-on="on">fa-trash-alt</v-icon>
                        </template>
                        <span>ELIMINAR</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-col>

                <v-divider></v-divider>

                <v-col v-if="confSubModulo.length == 0" class="text-center">
                  No tiene permisos para este submódulo
                </v-col>

                <v-col cols="12" v-for="item in confSubModulo" :key="item.id">
                  <v-row>
                    <v-col cols class="py-0">
                      <label class="black--text">{{
                        item.nombre_submodulo
                      }}</label>
                    </v-col>

                    <v-col cols="1" class="px-0 py-0">
                      <div class="d-flex justify-center">
                        <v-checkbox v-model="confSubModuloAll" :value="item.id" @change="marcarPermisosTodos(item.id)"
                          class="my-0" color="#8E8E8E" hide-details />
                      </div>
                    </v-col>

                    <v-col cols="1" class="px-0 py-0">
                      <div class="d-flex justify-center">
                        <v-checkbox v-model="confSubModuloV" :value="item.id" @change="marcarPermiso(item.id)"
                          class="my-0" color="#388e3c" hide-details />
                      </div>
                    </v-col>

                    <v-col cols="1" class="px-0 py-0">
                      <div class="d-flex justify-center">
                        <v-checkbox v-model="confSubModuloA" :value="item.id" @change="marcarPermiso(item.id)"
                          class="my-0" color="#01579b" hide-details />
                      </div>
                    </v-col>

                    <v-col cols="1" class="px-0 py-0">
                      <div class="d-flex justify-center">
                        <v-checkbox v-model="confSubModuloE" :value="item.id" @change="marcarPermiso(item.id)"
                          class="my-0" color="#ffbc00" hide-details />
                      </div>
                    </v-col>

                    <v-col cols="1" class="px-0 py-0">
                      <div class="d-flex justify-center">
                        <v-checkbox v-model="confSubModuloD" :value="item.id" @change="marcarPermiso(item.id)"
                          class="my-0" color="#e53935" hide-details />
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </template>
          </ComunDialogComp>
        </v-row>

        <v-divider></v-divider>

        <v-card-actions>
          <v-row dense>
            <v-col class="d-flex justify-end gap-10px">
              <ButtonComp :loading="loading" @click="saveItem()" text-button="Guardar" iconBut="fas fa-save"
                normalButton />

              <!-- <ButtonComp
                v-if="this.parametros.evento == 'agregar'"
                @click="savePermisosUsuario(10029)"
                classColor="black"
                text-button="probar SP"
                normalButton
              /> -->

              <ButtonComp @click="$emit('close', 'datosPersonal')" classColor="red" textButton="Cancelar" normalButton />
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <span v-if="test">
        <!-- <code> Datos :{{ Datos }} </code>
        <code> Parametros :{{ parametros }} </code>
        <code> Persona :{{ persona }} </code>
        <code> Personal :{{ personal }} </code> 
        <pre>{{ LicenciaTipo }}</pre>-->
      </span>
    </v-form>

    <!-- fin modal del Usuario -->
  </div>
</template>

<script>
import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import { validationRules } from "../../../../helpers/validatorHelpers";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

import { mask } from 'vue-the-mask'
import ComunDialogComp from "../../../../components/ComponentsEst/ComunDialogComp.vue";
import ButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import textfieldComp from "@/components/ComponentsEst/textfieldComp.vue";
import AutocompleteComp from "@/components/ComponentsEst/AutocompleteComp.vue";
import moment from "moment";

export default {
  name: "compUsuarios",
  components: {
    textfieldComp,
    AutocompleteComp,
    ButtonComp,
    ComunDialogComp,
  },
  directives: { mask },
  props: {
    parametros: {
      type: Object,
    },
    parametros2: {
      type: Array,
    },
    estadoComp: {
      type: Boolean,
    },
    parametrosUsers: {
      type: Object,
    },
  },

  data: () => ({
    datoLogin: sessionStorage,
    session: sessionStorage,
    rutaServer: API_URL,
    URL_SPACE: BUCKET_ORIGIN_SPACE,
    img: null,
    srcImg: null,
    dialogPermisos: false,
    dinamicValidation: [],
    Datos: [],
    test: true,
    docente: [],
    bloquearInput: false,
    fetchSalida: false,
    persona: [],
    personal: [],
    id_persona_creada: "",
    defaultPais: 145,
    loading: false,

    InputUpdate: false,
    avatar: {
      url: null,
      state: false,
    },
    configuracion: {},
    tipo_docente:[],
    modulo: [],
    confSubModulo: [],

    // Avatar  Persona imagen
    previewImgAvatar: "",
    imageSaveAvatar: "",
    // END Avatar Persona////////////////
    length: null,

    sexo: [
      { nombre: "Masculino", abbr: "M" },
      { nombre: "Femenino", abbr: "F" },
    ],
    type_personal: [
      { id: 3, desc_tipo_personal: "Coordinador" },
      { id: 10, desc_tipo_personal: "Administrativo" },
      { id: 11, desc_tipo_personal: "Director" },
      { id: 2, desc_tipo_personal: "WebMaster" },
    ],
    esDocente: false,

    //-- funciones del date picker de fecha
    // dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
    maxDateIngreso: moment(new Date()).format("YYYY-MM-DD"),
    menu2: false,
    menu3: false,
    menu4: false,

    tipo_personal: [],
    nacionalidades: [],
    motivo_salida: [],
    getDepartamentos: [],
    getProvincias: [],
    getDistritos: [],

    confSubModuloV: [],
    confSubModuloA: [],
    confSubModuloE: [],
    confSubModuloD: [],
    confSubModuloAll: [],

    //validaciones de formulario

    //Variables para los campos del form usuario
    show: false,
    password_usuario: "",
    habilitarUsMaster: false,
    Perfil: [],
    TipoDocumentos: [],
    Colegio: [],
    Paises: [],
    Ubicacion1: [],
    perfilFiltered: {},
    userParams: {},
    perfilEdit: false,
    LicenciaTipo: [],
    id_licencia: 0,
    Licencia: [],
    tipoDocente: [],
    cantidadHoras: [
      { value: "20" },
      { value: "30" },
      { value: "40" },
      { value: 'personalizado' }],
    bloquearInput2: true,
    
    nivel:[],
    listAreas:[]
  }),

  mounted() {
    this.loadMain();
    this.getTiposDocentes();

  },

  //computadas
  computed: {
    validationRules() {
      return validationRules;
    },

    formTitle() {
      return this.parametros.evento === "agregar"
        ? "Crear Usuario"
        : "Editar Usuario";
    },

    ...mapGetters("login", ["componenteEvento"]),

    ...mapState([
      "TiposDocumentos",
      "paises",
      "estadosCiviles",
      "discapacidades",
    ]),

    ...mapGetters([
      "getTipoDocumentos",
      "getPaises",
      //"getNacionalidades",
      "getEstadosCiviles",
      "getDiscapacidades",
    ]),

    // Maxima Fecha Calendario fecha actual
    getEndDate() {
      return moment(new Date()).format("YYYY-MM-DD");
      //return new Date().toISOString().substr(0, 10);
    },

    //fecha de Nacimiento mayor de 18 años
    fechaMayorEdad() {
      var f = new Date();
      var mes = f.getMonth() + 1;
      var anio = f.getFullYear();
      var mianio = anio - 18;

      if (mes < 9) {
        mes = `0${mes}`;
      }
      var fecha_actual = mianio + "-" + mes + "-" + f.getDate();
      return fecha_actual;
    },

    computedDateFormatted() {
      return this.formatDate(this.persona.fecnac_persona);
    },

    computedDateFormatted3() {
      return this.personal.fecha_ingreso
        ? moment(this.personal.fecha_ingreso).format("DD/MM/YYYY")
        : "";
      //return moment(this.personal.fecha_ingreso).utc().format('DD/MM/YYYY');
      //return this.formatDate(this.personal.fecha_ingreso);
    },

    computedDateFormatted4() {
      return this.formatDate(this.personal.fecha_salida);
    },

    // Lo comente porque no hace nada 
    // mostrarRadioDocente() {
    //   //habilitar este array con valores hara que salga la opcion en el formulario para asignarle ser docente o no a los id de este array
    //   // const perfilesMostrar = [2, 3, 10, 11]
    //   const perfilesMostrar = [];
    //   return perfilesMostrar.includes(this.personal.id_tipo_personal);
    // },


  },

  watch: {
    // cada vez que la pregunta cambie, esta función será ejecutada
    estadoComp: function () {
      if (this.estadoComp) {
        this.loadMain();

        // this.persona.numdoc_persona = this.docuemnto_validar;
      } else {
        this.limpiarForm();
      }
    },
    "personal.id_tipo_personal": function (id_tipo_personal) {
      if (id_tipo_personal == 8) {
        this.personal.es_profesor = 1;
        this.esDocente = true;
      } else {
        this.personal.es_profesor = 0;
        this.esDocente = false;
      }
   },
  },
  methods: {
    ...mapMutations({
      setEnviarMens: "mensajeSis/setEnviarMens",
    }),
    ...mapActions({
      getAllTiposDocumentos: "getAllTiposDocumentos",
      getAllPaises: "getAllPaises",
      getAllTiposEstadosCiviles: "getAllTiposEstadosCiviles",
      getAllDiscapacidades: "getAllDiscapacidades",
    }),
    /**
     ________________________
    | MÉTODO CARGA INICIAL */
    async loadMain() {
      this.limpiarForm();
      
     
      

      if (this.parametros.evento == "agregar") {

        this.fetchSalida = false;
        this.perfilEdit = false;
        this.persona.id_persona = 0;
        this.persona.id = 0;
        this.srcImg = null;
        this.img = null;
        this.avatar.url = null; //Limpia la imagen del Personal anterior

        this.persona.numdoc_persona = this.parametros.item.numdoc_persona;
        this.persona.password_usuario = `${this.parametros.item.numdoc_persona}`;
        this.persona.usu_usuario = `${this.parametros.item.numdoc_persona}-${this.datoLogin.id_colegio}`;
      }
      const numdocLength = String(this.persona.numdoc_persona).length;

      if (numdocLength >= 8 && numdocLength < 9) {
        this.persona.id_tipo_documento = 1;
      } else if (numdocLength >= 9) {
        this.persona.id_tipo_documento = 2;
      }
      this.getQuery();
      this.getQueryUsers();
      this.getPersonaWhenExist();
      

      if (this.parametros.evento == "editar") {
        this.fetchSalida = true;
        this.editItem(this.parametros.item);
       
      }
      this.userParams = this.parametrosUsers;
      
    },

  

   
    remove(item) {
  // Eliminación condicional en persona.id_nivel
  if (this.persona.id_nivel && this.persona.id_nivel.includes(item.id)) {
    const index = this.persona.id_nivel.indexOf(item.id);
    if (index >= 0) {
      this.persona.id_nivel.splice(index, 1);
     
    }
  }

  // Eliminación condicional en persona.areas
  if (this.persona.areas && this.persona.areas.includes(item.id)) {
    const index2 = this.persona.areas.indexOf(item.id);
    if (index2 >= 0) {
      this.persona.areas.splice(index2, 1);
    }
  }
},



    changedinamicValidation(id) {
      switch (id) {
        case 1:
          this.dinamicValidation = validationRules.validateDni;
          break;
        case 2:
          this.dinamicValidation = validationRules.validateDocument;
          break;
        case 4:
          this.dinamicValidation = validationRules.validateRuc;
          break;

        default:
          break;
      }
    },

    async getAllDepartamentosId(id) {
      if (!id) return;
      try {
        let response = await axios.get("/mantenimiento/ubicacion1/" + id + "");
        this.getDepartamentos = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    // LLena los campos del formulario cuando ya existe la persona
    async getPersonaWhenExist() {
      const persona = await axios.get(`/sistema/persona/numDocumento/${this.parametros.item.numdoc_persona}`)
   
      if (!persona.data || Object.keys(persona.data).length === 0) return; // Retorna aquí si no hay datos
    
    
      this.personal = Object.assign({}, persona.data.personal);
      this.persona = Object.assign({}, persona.data);
      this.personal.id_tipo_personal = persona.data.personal.id_tipo_personal;
      this.persona.id_persona = this.persona.id;
      this.persona.id_usuario = this.datoLogin.id;
      this.avatar.url = null; //Limpia la imagen del Personal anterior
      this.get_avatarImg();
      this.get_Nacionalidades(this.persona.id_pais_nacimiento);
      this.getAllDepartamentosId(this.persona.id_pais);
      this.getAllProvinciasId(this.persona.id_ubicacion1);
      this.getAllDistritosId(this.persona.id_ubicacion2);


      this.persona.usu_usuario = `${this.persona.numdoc_persona}-${this.datoLogin.id_colegio}-`;
      this.persona.password_usuario = `${this.persona.numdoc_persona}-${this.datoLogin.id_colegio}`;
    },

    //////////// Registro de Usuario ////////////////////
    ///////// Evento --> Crear /////////////
    async getQueryUsers() {
      try {
        let response = await axios.get(
          "/sistema/usuario/getQuery/" + this.datoLogin.id_colegio
        );

        this.Colegio = response.data.colegio;
        this.TipoDocumentos = response.data.tipoDocumento;
        // this.Perfil = response.data.perfil;
        let filterPerfil = response.data.rolPerfil.filter(
          (e) => !["estudiante", "familiar"].includes(e.desc_rol_licencia)
        );
        this.Perfil = filterPerfil;
        this.Paises = response.data.pais;
        this.Ubicacion1 = response.data.ubicacion1;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
    __________________________________
   | MÉTODO CARGAR TIPO DE LICENCIA */
    async cargarLicenciaTipo(perfil) {
      try {
        this.persona.id_licencia = 0;
       
        if (!perfil) {
          throw new Error(
            "No se han asignado licencias para el tipo de personal o perfil seleccionado"
          );
        }

        let params = `/sistema/usuario/perfilLicenciaTipo/colegio/${this.datoLogin.id_colegio}/perfil/${perfil}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(params);
     
        if (!response.data || response.data.length == 0) {
          throw new Error(
            "No se ha asignado ningun tipo de licencia a este perfil"
          );
        }

        this.LicenciaTipo = response.data;

        if (this.parametros.evento == 'agregar') {

          this.persona.id_licencia_tipo = this.LicenciaTipo[0].id_licencia_tipo;
          this.persona.usu_usuario = `${this.parametros.item.numdoc_persona}-${this.datoLogin.id_colegio}-${this.persona.id_perfil}`;
          //README INICIO  => is.gd/DSouWo ↓
          this.configuracion.id_colegio = this.datoLogin.id_colegio;
          this.configuracion.id_licencia_tipo = this.LicenciaTipo[0].id_licencia_tipo;
          this.configuracion.id_perfil = perfil;
          //README FIN
     
          await this.cargarLicencia();
          await this.cargarAllSubModulo();
        }
       
      } catch (error) {
        if (error.response) {
          // Si es una respuesta de axios, mostrará información adicional sobre el error
          this.setEnviarMens({
            tipo: "E",
            mensaje: `Error de red: ${error.message}`,
            tiempo: null,
          });
        } else {
          // Si es una excepción genérica
          this.setEnviarMens({
            tipo: "E",
            mensaje: `${error.message}`,
            tiempo: null,
          });
        }
        // Lanzar la excepción nuevamente para que otros controladores de errores superiores puedan manejarla si es necesario
        throw error;
      }
    },
    /**
    _______________________________________________
   | MÉTODO CARGAR LICENCIA POR TIPO DE LICENCIA */
    async cargarLicencia() {
      try {
        let params = `/sistema/usuario/licenciaDisponibles/licenciaTipo/${this.persona.id_licencia_tipo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(params);

        if (
          !response.data ||
          !Array.isArray(response.data) ||
          response.data.length === 0
        ) {
          // Si la respuesta no contiene datos o no es un arreglo o está vacío,
          // lanzar una excepción
          this.persona.id_perfil = "";
          this.persona.id_licencia_tipo = "";
          this.$forceUpdate();
          throw new Error(
            "No se encontraron licencias disponibles para este perfil."
          );
        }
        // Asignar la primera licencia disponible
        this.Licencia = response.data;
        this.persona.id_licencia = this.Licencia[0].id;
      } catch (error) {
        if (error.response) {
          // Si es una respuesta de axios, mostrará información adicional sobre el error
          this.setEnviarMens({
            tipo: "E",
            mensaje: `Error de red: ${error.message}`,
            tiempo: null,
          });
        } else {
          // Si es una excepción genérica
          this.setEnviarMens({
            tipo: "E",
            mensaje: `${error.message}`,
            tiempo: null,
          });
        }
        // Lanzar la excepción nuevamente para que otros controladores de errores superiores puedan manejarla si es necesario
        throw error;
      }
    },

    //----metodo para manejar si el usuario coloca una cantidad de hora_academica personalizada-------

 

    /** Metodo para consultar los tipos de Docentes */

    async getTiposDocentes() {

      try {
        let response = await axios.get("/mantenimiento/tiposdocentes");
      if(response.data.messageT == 'E' || response.data.length == 0) return
        this.tipoDocente = response.data.map(item => {
          return {
            id: item.id,
            desc_tipo_docente: item.desc_tipo_docente
          };
        });

        // Retorna el array mapeado
        return this.tipoDocente;

      } catch (error) {
        console.log(error)
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    /** metodo para consultar los niveles de los docentes*/
  


      /*Esta es la peticion para solicitud de areas por niveles*/
      
   
    
    /**
    _____________________________
   | MÉTODO Evento ---> Editar */
    async getUserCredentialData() {
      
      let userCredentialResult = await axios.get(
        `/sistema/usuario/userCredential/${this.parametros.item.id_persona}`
      );
      
      let userPerfilFiltered = userCredentialResult.data.filter(e =>  e.desc_tipo_licencia == this.parametros.item.desc_tipo_personal)
      let tipoPersonalFiltered = this.tipo_personal.filter( e => e.desc_tipo_personal == userPerfilFiltered[0].desc_tipo_licencia)
      this.perfilEdit = true;
      this.personal.id_tipo_personal = tipoPersonalFiltered[0].id 

      setTimeout(() => {
      
        this.persona.usu_usuario = userPerfilFiltered[0].usu_usuario;
        this.persona.fecha_fin = userPerfilFiltered[0].fecha_fin;
        this.cargarLicenciaTipo(userPerfilFiltered[0].id_perfil);
        this.persona.id_perfil = userPerfilFiltered[0].id_perfil;
        this.persona.id_licencia_tipo = userPerfilFiltered[0].id_tipo_licencia;
        this.persona.serie_licencia = userPerfilFiltered[0].serie_licencia; 
        
      }, 500);
    },
    /**
    ________________________________________________
   | MÉTODO FILTRADO DE PERFIL Y TIPO DE PERSONAL */
    async filterPerfilByTipoPersonal(id) {

      this.persona.id_perfil = 0
      this.persona.id_licencia_tipo = 0
      this.persona.id_licencia = 0

      await this.getAllTipoPersonal()
      await this.getQueryUsers()
      let filterTipoPersonal = this.tipo_personal.filter(e => e.id == id)

      let filterData = this.Perfil.filter(p => filterTipoPersonal.some(tp => String(tp.desc_tipo_personal).toLowerCase() === String(p.desc_rol_licencia).toLowerCase()));

      this.Perfil = filterData;

    },
    /**
    __________________________________
   | MÉTODO OBTENER DATOS GENERALES */
    async getQuery() {
      this.getAllTiposDocumentos();
      this.getAllPaises();
      this.getAllTiposEstadosCiviles();
      this.getAllDiscapacidades();
      this.getAllMotivoSalida();
      this.getAllTipoPersonal();

      this.getAllDepartamentosId(this.persona.id_pais);
    },
    /**
    ____________________________________
   | MÉTODO OBTENER DATOS PARA EDITAR */
    async editItem(item) {
      this.avatar.url = null; //Limpia la imagen del Personal anterior
    //  this.personal.id_tipo_personal = 0  //esto lo acabo de comentar
      this.bloquearInput = false;
      this.personal = Object.assign({}, item);
      this.persona = Object.assign({}, item);
      this.persona.id_usuario = this.datoLogin.id;
      this.get_avatarImg();
      this.get_Nacionalidades(item.id_pais_nacimiento);
      this.getAllDepartamentosId(this.persona.id_pais);
      this.getAllProvinciasId(this.persona.id_ubicacion1);
      this.getAllDistritosId(this.persona.id_ubicacion2);
      this.getUserCredentialData();
       if(this.personal.id_tipo_personal == 8){
         this.getDocente();
       }
    },
    /**
    _________________________
   | MÉTODO GUARDAR DATOS  */
    async saveItem() {
      this.loading = true;
    
      if (this.$refs.formDatosPersonales.validate()) {
      
        try {
          ////////  CREAR PERSONAL REQUEST ////////////////
          this.persona.evento = this.parametros.evento;

          let params = { persona: this.persona, personal: this.personal };
      
          const response = await axios.post("/administrativo/personal", params);
          if(!response.data && response.data.length == 0){
            this.setEnviarMens({
              tipo: data.messageT,
              mensaje: data.message,
              tiempo: "null",
            });
            return
          }
          this.personal.id = response.data.id_personal;
          this.id_persona_creada = response.data.id_persona;


          ////////  CREAR USUARIOS REQUEST ////////////////
          let { data } = await axios.post("/sistema/usuario/", this.persona);

          if (data.success) {
            this.savePermisosUsuario(data.id_new_usuario);

            this.setEnviarMens({
              tipo: data.messageT,
              mensaje: data.message,
              tiempo: "null",
            });

          } else {
            this.setEnviarMens({
              tipo: data.messageT,
              mensaje: data.message,
              tiempo: "null",
            });
          }
          ////////  EDITAR USUARIOS REQUEST ////////////////
          this.perfilEdit = false;
          if (this.evento == "editar") {
            let { data } = await axios.put(
              "/sistema/usuario/" + this.datos.id,
              this.datos
            );
            if (data.success) {
              this.setEnviarMens({
                tipo: data.messageT,
                mensaje: data.message,
                tiempo: "null",
              });
            } else {
              this.setEnviarMens({
                tipo: data.messageT,
                mensaje: data.message,
                tiempo: "null",
              });
            }
          }
          //////// IMAGEN DE USUARIO /////////////

          if (this.imageSaveAvatar) {
            this.saveAvatar(this.id_persona_creada);
          } else {
            this.dialog = false;
            this.loadMain();
            this.limpiarForm();
          }

          /////////////////// FIN GESTION DE USUARIOS ///////////////////////////////

          this.dialog = false;
          this.loading = false;
          if (this.parametros.evento == "agregar") {
            this.metodo = "editar";
            this.disabled_tabs = false;

            this.setEnviarMens({
              tipo: "S",
              mensaje: `¡Información creada con éxito!`,
              tiempo: null,
            });
          } else if (this.parametros.evento == "editar") {
            this.setEnviarMens({
              tipo: "S",
              mensaje: `¡Información editada con éxito!`,
              tiempo: null,
            });
          }
          this.InputUpdate = false;

          // SAVE AVATAR
          if (this.previewImgAvatar && this.imageSaveAvatar) {
            this.saveAvatar();
            this.$emit("close", "datosPersonal");
          } else {
            this.$emit("reloadComp", "datosPersonal");

            if (
              this.parametros.evento == "agregar" ||
              this.parametros.evento == "editar"
            ) {
              this.$emit("close", "datosPersonal");
            }
          }
          this.$emit('usuarioCreado');

        } catch (error) {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `Error: ${error}`,
            tiempo: null,
          });
        }

      }
      else{
        this.loading = false;
        this.setEnviarMens({
            tipo: "W",
            mensaje: `Debe llenar todos los campos requeridos.`,
            tiempo: null,
          });
      }
    },
    /**
    ____________________________
   | MÉTODO SELECCIONAR PAIS  */
    async select_pais() {
      this.get_Nacionalidades(this.persona.id_pais_nacimiento);
    },
    /**
    __________________________________
   | MÉTODO OBTENER NACIONALIDADES  */
    async get_Nacionalidades(id = "") {
      //this.persona.id_nacionalidad = 0;

      let url = "/mantenimiento/nacionalidades";
      if (id != "" && id != undefined) {
        url = `${url}/pais/${id}/`;
      }
      await axios.get(url).then((response) => {
        this.nacionalidades = response.data;
      });
    },
    /**
     ____________________________________________________
    | MÉTODO MOSTRAR PROVINCIA POR ID DE DEPARTAMENTO  */
    async getAllProvinciasId(id) {
      if (!id) return;
      try {
        let response = await axios.get("/mantenimiento/ubicacion2/" + id + "");
        this.getProvincias = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
    _________________________________________________
   | MÉTODO MOSTRAR DISTRITOS POR ID DE PROVINCIA  */
    async getAllDistritosId(id) {
      if (!id) return;
      try {
        let response = await axios.get("/mantenimiento/ubicacion3/" + id + "");
        this.getDistritos = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
    __________________________________
   | MÉTODO  MOSTRAR MOTIVO SALIDA  */
    async getAllMotivoSalida() {
      try {
        let response = await axios.get("/mantenimiento/motivosalida");
        this.motivo_salida = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //--- metodo para consultar la Informacion de Docente

    async getDocente() {

      try {
        // Asegúrate de que estás enviando un objeto con la propiedad 'numdoc_persona'
        let response = await axios.post("/administrativo/personal/getdocentes/numdoc", {
          numdoc_persona: this.parametros.item.numdoc_persona
        });
        
        if(response.data.messageT == 'E' || response.data.length == 0) return
        this.docente = response.data;
        this.persona.tipo_docente = this.docente.payload[0].tipo_docente;
        this.persona.cantidad_horaacademica = this.docente.payload[0].cantidad_horaacademica;
        this.persona.horaPersonalizada = this.docente.payload[0].hora_personalizada;
        this.persona.id_nivel= this.docente.payload[0].id_nivel;
        this.persona.areas= this.docente.payload[0].areas;
      
       
       
      } catch (error) {
        console.error(error);
      }
    },
    /**
    ____________________________________
   | MÉTODO  MOSTRAR TIPO DE PERSONAL */
    async getAllTipoPersonal() {
      try {
        let response = await axios.get("/mantenimiento/tipospersonales");


        let propsParamsUsers = this.parametros2
        let filteredTipoPersonal = response.data.filter(personal => !propsParamsUsers.some(valueExclude => valueExclude.id_mant_tipo_personal == personal.id))

        this.tipo_personal = filteredTipoPersonal;
       


      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
       
      }
    },
    /**
    _________________________
   | MÉTODO GUARDAR AVATAR */
    saveAvatar() {
      let formData = new FormData();
      formData.append("subirArchivo", this.imageSaveAvatar);
      formData.append("id_colegio", this.datoLogin.id_colegio);
      formData.append("id_usuario", this.datoLogin.id);
      formData.append("id_persona", this.id_persona_creada);

      axios
        .post("archivo/avatarPersona", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          this.$emit("reloadComp", "datosPersonal");

          if (this.parametros.evento == "agregar") {
            this.$emit("close", "datosPersonal");
          }
        })
        .catch(function () {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `Error en Subir Imagen`,
            tiempo: null,
          });
        });
    },
    /**
    _____________________________
   | MÉTODO VISUALIZAR IMAGEN  */
    async get_avatarImg() {
      if (this.persona.avatar_persona == null) return null;
      const url = `${this.URL_SPACE}/${this.persona.ruta_avatar_persona}`;
      //const url = `${this.URL_SPACE}/${this.persona.ruta_avatar_persona}`? `nocache=${new Date().getTime()}` : ``
      this.avatar.url = url;

      //Limpiar la imagen escogida
      this.srcImg = null;
      this.img = null;
    },
    /**
    _____________________________________
   | MÉTODO SUBIR LOGO AVATAR PERSONA  */
    pickAvatar() {
      // activar imput tipo file
      this.$refs.imageAvatar.click();
    },
    /**
    _______________________________________________
   | MÉTODO SELECCION DEL ARCHIVO POR EL USUARIO */
    onFileAvatar(e) {
      const file = e.target.files[0];
      if (file) {
        this.img = file;
        this.srcImg = URL.createObjectURL(file);
      }
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      // crea imagen temporar para visualizar
      this.createImageAvatar(files[0]);

      if (files[0] !== undefined) {
        this.imageSaveAvatar = files[0]; // this is an image file that can be sent to server...
      }
    },
    /**
    _________________________________________
   | MÉTODO PARA CREAR UNA IMAGEN TEMPORAL */
    createImageAvatar(file) {
      var reader = new FileReader();
      // var vm = this;
      reader.onload = (e) => {
        this.previewImgAvatar = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    /**
    _____________________________
   | MÉTODO LIMPIAR FORMULARIO */
    limpiarForm() {
      this.persona = {
        id_usuario: this.datoLogin.id,
        id_colegio: this.datoLogin.id_colegio,
        id_pais: this.defaultPais,
        ruta_avatar_persona: null,
        avatar_persona: null,
        ape2_persona: null,
        direc_persona: null,
        correo_persona: null,
        telf_persona: null,
        cel_persona: null,
        evento: null,
        estado_persona: 0,
        estado_usuario: 1,
        id_tipo_usuario: null,
      };

      this.personal = {
        cv_personal: null,
        doc_identificacion_personal: null,
        fecha_salida: null,
        id_motivo_salida: null,
        observacion_personal: null,
        codigo_postal: null,
        estado_personal: 0,
        es_profesor: 0,
      };

      this.resetValidation();
      this.previewImgAvatar = null;
    },
    /**
    _______________________________
   | MÉTODO RESETEAR FORMULARIO  */
    resetValidation() {
      this.$refs.formDatosPersonales.resetValidation();
    },
    /**
    ___________________________________
   | MÉTODO VALIDAR NUMERO TELEFONO  */
    text($event) {
      this.$options.filters.text($event);
    },
    /**
    ___________________________________
   | MÉTODO VALIDAR NUMERO TELEFONO  */
    validarNumeroTelefono: ($event) => {
      let keyCode = $event.keyCode;
      let digito = $event.key;
      if (
        isNaN(digito) &&
        keyCode !== 187 &&
        keyCode !== 8 &&
        keyCode !== 37 &&
        keyCode !== 39
      ) {
        return $event.preventDefault();
      }
      return true;
    },
    /**
    ______________________________________
   | MÉTODO VALIDACION INPUT TIPO FECHA */
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    /**
    _____________________________________________
   | MÉTODO ABRIR MODAL CONF PERMISOS USUARIOS */
    async configPermisos() {
      this.dialogPermisos = true;
      this.cargarModuloperfil();
    },
    /**
    ________________________________________________
   | MÉTODO CARGAR SUBMODULO DEL TIPO DE LICENCIA */
    async cargarModuloperfil() {
      try {
        const response = await axios.get(
          `/sistema/perfilColegio/modulosTlicencia/${this.configuracion.id_colegio}/${this.configuracion.id_licencia_tipo}`
        );
        this.modulo = response.data;
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    /**
    ____________________________________________
   | MÉTODO SELECCIONA TODOS CHECKBOX PERMISO */
    marcarPermisosTodos(itemID) {
      if (this.confSubModuloAll.includes(itemID)) {
        this.confSubModuloV.push(itemID);
        this.confSubModuloA.push(itemID);
        this.confSubModuloE.push(itemID);
        this.confSubModuloD.push(itemID);
      } else {
        const indexV = this.confSubModuloV.indexOf(itemID);
        const indexA = this.confSubModuloA.indexOf(itemID);
        const indexE = this.confSubModuloE.indexOf(itemID);
        const indexD = this.confSubModuloD.indexOf(itemID);
        if (indexV > -1) this.confSubModuloV.splice(indexV, 1);
        if (indexA > -1) this.confSubModuloA.splice(indexA, 1);
        if (indexE > -1) this.confSubModuloE.splice(indexE, 1);
        if (indexD > -1) this.confSubModuloD.splice(indexD, 1);
      }
    },
    /**
    ______________________________________
   | MÉTODO SELECCIONA CHECKBOX PERMISO */
    marcarPermiso(itemID) {
      if (
        this.confSubModuloV.includes(itemID) &&
        this.confSubModuloA.includes(itemID) &&
        this.confSubModuloE.includes(itemID) &&
        this.confSubModuloD.includes(itemID)
      ) {
        this.confSubModuloAll.push(itemID);
      } else {
        const index = this.confSubModuloAll.indexOf(itemID);
        if (index > -1) this.confSubModuloAll.splice(index, 1);
      }
    },
    /**
    ___________________________________________
   | MÉTODO CARGAR SUBMODULOS POR ID Y TODOS */
    async cargarAllSubModulo() {
      if (this.configuracion.id_perfil != null) {
        try {
          this.configuracion.id_modulo = "";
          let response = await axios.post(
            "/sistema/perfilColegio/confSubModuloPerfil",
            this.configuracion
          );

          this.confSubModulo = response.data.subModulo;
          this.confSubModuloV = response.data.confSubModuloV;
          this.confSubModuloA = response.data.confSubModuloA;
          this.confSubModuloE = response.data.confSubModuloE;
          this.confSubModuloD = response.data.confSubModuloD;
        } catch (e) {
          (console.error || console.log).call(console, e.stack || e);
        }
      }
    },
    /**
    ___________________________________________
   | MÉTODO CARGAR SUBMODULOS POR ID Y TODOS */
    async cargarSubModulo() {
      if (
        this.configuracion.id_perfil != null &&
        this.configuracion.id_modulo != null
      ) {
        try {

          let response = await axios.post(
            "/sistema/perfilColegio/confSubModuloPerfil",
            this.configuracion
          );
          this.confSubModulo = response.data.subModulo;
          this.confSubModuloV = response.data.confSubModuloV;
          this.confSubModuloA = response.data.confSubModuloA;
          this.confSubModuloE = response.data.confSubModuloE;
          this.confSubModuloD = response.data.confSubModuloD;
        } catch (e) {
          (console.error || console.log).call(console, e.stack || e);
        }
      }
    },
    /**
    ______________________________________
   | MÉTODO GUARDAR PERMISOS DE USUARIO */
    async savePermisosUsuario(idusuario) {
      try {
        let params = {
          id_usuario_new: idusuario,
          configuracion: this.configuracion,
          subModulo: this.confSubModulo,
          confSubModuloV: this.confSubModuloV,
          confSubModuloA: this.confSubModuloA,
          confSubModuloE: this.confSubModuloE,
          confSubModuloD: this.confSubModuloD,
          id_usuario: this.datoLogin.id,
        };

        await axios.post(
          "/sistema/perfilColegio/saveConfigUsuario",
          params
        );

      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
  },
};
</script>

<style scoped>
.fondo_add_img {
  cursor: pointer;
  cursor: hand;
  max-width: 100%;
  /* Esto asegura que la imagen no sea más ancha que su contenedor */
  max-height: 100%;
  /* Esto asegura que la imagen no sea más alta que su contenedor */
  height: auto;
  /* Esto mantiene la proporción original de la imagen */
}

.avatar_fondo_add_img {
  border-radius: 10%;
  border: solid 1px rgb(197, 197, 197);
  border-style: dashed;
}

.chip-custom {
  color: rgb(30, 30, 142);
}
</style>
